import {inject} from '@angular/core';
import {CanActivateFn,Router} from '@angular/router';
import {firstValueFrom} from 'rxjs';
import {AuthService} from '../services/auth.service';
export const profileTenantGuard:CanActivateFn=async route=>{
 const auth=inject(AuthService),router=inject(Router),raw=route.queryParamMap.get('companyId');
 if(!raw)return true;const id=Number(raw);if(!Number.isSafeInteger(id)||id<=0)return router.createUrlTree(['/flow-error']);
 const current=auth.getCustomer();if((current?.companyId||current?.company?.id)===id)return true;
 try{await firstValueFrom(auth.switchTenant({companyId:id}));return true;}catch{return router.createUrlTree(['/flow-error']);}
};
